<template>
  <div class="login-page">
<!--    <app-navbar></app-navbar>-->
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <b-row>
                <b-col>
                  <form @submit.prevent="login">
                    <card type="login">
                      <b-row>
                        <b-col cols="12">
                          <img class="mb-2" :src="$store.state.logoFull"  :alt="$store.state.site_name">
                        </b-col>
                        <b-col cols="12">
                          <h3 slot="header" class="header text-center mb-2">{{$t('views.login.index.login')}}</h3>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div v-if="error" class="alert alert-danger" role="alert">
                            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <fg-input v-model="form.username" addon-left-icon="nc-icon nc-single-02"
                                    :placeholder="$t('views.login.form.username')"></fg-input>

                          <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25" :placeholder="$t('views.login.form.password')"
                                    type="password" class="mb-2"></fg-input>

                          <p-button native-type="submit" slot="footer" type="warning" round block >{{$t('views.login.form.login')}}</p-button>

                          <div class="text-center mt-2">
                            <hr class="my-0">
                            <b-link :href="$http.defaults.baseURL + 'resetting/request'">{{ $t('views.login.index.forgotPassword') }}</b-link>
                            <hr class="my-0">
                            <b-link :href="$http.defaults.baseURL + 'register'">{{ $t('views.login.index.registration') }}</b-link>
                          </div>
                        </b-col>
                      </b-row>
                    </card>
                  </form>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
<!--        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>-->
        <div class="full-page-background" style=""></div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Card, Checkbox, Button } from 'src/components/UIComponents'
import AppFooter from './Layout/AppFooter'
import VueCookie from 'vue-cookie'
import moment from 'moment'

Vue.use(VueCookie)
export default {
  components: {
    Card,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    login () {
      let data = JSON.stringify({
        password: this.form.password,
        username: this.form.username
      })
      this.$http.defaults.headers.common = {
        // 'Authorization': 'Bearer ' + VueCookie.get('accessToken'),
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }
      this.$http
        .post(this.$http.defaults.baseURL + 'api/login_check', data,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then(response => {
          VueCookie.set('excm_accessToken', response.data.token, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('excm_refreshToken', response.data.refresh_token, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('expires_in', moment().add((response.data.exp - response.data.iat), 's').unix(), {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('user_id', response.data.data.id_user, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('user_data_id', response.data.data.id_user_data, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('name', response.data.data.name, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('surname', response.data.data.surname, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('roles', JSON.stringify(response.data.data.roles), {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('user_employer', response.data.data.user_employer, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('id_client_type', response.data.data.id_client_type, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('default_route', response.data.data.default_route, {
            expires: (response.data.exp - response.data.iat) + 's'
          })
          VueCookie.set('default_disable_roles_filtering', response.data.data.default_disable_roles_filtering, {
            expires: (response.data.exp - response.data.iat) + 's'
          })

          let roles = response.data.data.roles
          let defaultRoute = response.data.data.default_route
          if (defaultRoute) {
            this.$router.push(defaultRoute)
          } else if (roles.includes('ROLE_CLIENT') || roles.includes('ROLE_WHOLESALER')) {
            this.$router.push({ name: 'DashboardClient' })
          } else {
            this.$router.push({ name: 'TimetableDashboard' })
          }

          this.$http.defaults.headers.common = {
            'Authorization': 'Bearer ' + VueCookie.get('excm_accessToken'),
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
          // this.fetchUserData(response.data.exp + 's')
        })
        .catch(error => {
          console.log(error)
          this.error = this.$t('views.login.index.wrongData')
        })
    },
    fetchUserData (expires_in = 0 + 's') {
      this.$http
        .get(this.$store.state.api.data_api + 'http://172.18.56.31:8002/users/auth')
        .then(response => {
          this.$store.state.user = response.data
          this.$router.push('/')
        })
        .catch(error => {
          // this.$swal({
          //   type: 'error',
          //   title: 'Błąd :' + error,
          //   showConfirmButton: true,
          //   timer: 7000
          // })
          console.log(error)
          this.$router.push({ path: '/500' })
        })
    }
  },
  data () {
    return {
      moment,
      error: '',
      form: {
        username: '',
        password: ''
      }
    }
  },
  beforeDestroy () {
    this.closeMenu()
  }
}
</script>
<style>

</style>
